import { render } from "./Explorer.vue?vue&type=template&id=2472f3b4&scoped=true"
import script from "./Explorer.vue?vue&type=script&lang=js"
export * from "./Explorer.vue?vue&type=script&lang=js"

import "./Explorer.vue?vue&type=style&index=0&id=2472f3b4&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2472f3b4"]])

export default __exports__